const VARIANT_WIDTHS = {
  thumb: 320,
  mobile: 480,
  medium: 640,
  tablet: 960,
  large: 1200,
  content: 1200,
  desktop: 1920
}

export const DEFAULT_VARIANT_ORDER = ['desktop', 'large', 'content', 'tablet', 'medium', 'mobile', 'thumb', 'cover']

export function responsiveImageUrl (record, preferred = DEFAULT_VARIANT_ORDER, fallback = '') {
  const source = record || {}
  const original = source.image || fallback || ''
  const variants = source.image_variants && typeof source.image_variants === 'object'
    ? source.image_variants
    : {}
  const order = Array.isArray(preferred) && preferred.length
    ? preferred
    : (preferred ? [preferred] : DEFAULT_VARIANT_ORDER)
  return order.map(name => variants[name]).find(Boolean) || original
}

export function responsiveImageSources (original, variants, preferred = DEFAULT_VARIANT_ORDER) {
  const record = { image: original || '', image_variants: variants || {} }
  const src = responsiveImageUrl(record, preferred, original)
  const srcset = Object.keys(record.image_variants)
    .filter(name => record.image_variants[name] && VARIANT_WIDTHS[name])
    .sort((a, b) => VARIANT_WIDTHS[a] - VARIANT_WIDTHS[b])
    .map(name => `${record.image_variants[name]} ${VARIANT_WIDTHS[name]}w`)
    .join(', ')
  return { src, srcset, original: original || '' }
}

export function responsiveBackgroundImage (record, preferred = DEFAULT_VARIANT_ORDER, fallback = '') {
  const original = (record && record.image) || fallback || ''
  const selected = responsiveImageUrl(record, preferred, fallback)
  const urls = selected && original && selected !== original ? [selected, original] : [selected || original]
  return urls.filter(Boolean).map(url => `url(${JSON.stringify(url)})`).join(', ')
}

function normalizedAssetKey (value) {
  if (!value) return ''
  const decoded = (() => {
    try { return decodeURIComponent(String(value)) } catch (error) { return String(value) }
  })()
  return decoded.replace(/^https?:\/\/[^/]+/i, '').replace(/^\/api\/images\//, '/storage/')
}

function variantsForImage (mapping, source) {
  if (!mapping || !source) return null
  if (mapping[source]) return mapping[source]
  const key = normalizedAssetKey(source)
  return Object.keys(mapping).reduce((found, candidate) => {
    return found || (normalizedAssetKey(candidate) === key ? mapping[candidate] : null)
  }, null)
}

export function enhanceContentImages (element, mapping) {
  if (!element || !element.querySelectorAll || !mapping || typeof mapping !== 'object') return
  Array.prototype.forEach.call(element.querySelectorAll('img[src]'), image => {
    const current = image.getAttribute('data-responsive-original') || image.getAttribute('src')
    const variants = variantsForImage(mapping, current)
    if (!variants) return
    const sources = responsiveImageSources(current, variants)
    if (!sources.src || sources.src === current) return
    image.setAttribute('data-responsive-original', current)
    image.setAttribute('src', sources.src)
    if (sources.srcset) {
      image.setAttribute('srcset', sources.srcset)
      image.setAttribute('sizes', '(max-width: 767px) 100vw, 1200px')
    }
    image.onerror = function () {
      const original = this.getAttribute('data-responsive-original')
      this.onerror = null
      this.removeAttribute('srcset')
      this.removeAttribute('sizes')
      if (original) this.setAttribute('src', original)
    }
  })
}
